if (!customElements.get('lc-delivery-estimator')) {
  class LcDeliveryEstimator extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cutoffHour = parseFloat(this.dataset.cutoff || '14');
      this.deliveryDays = parseInt(this.dataset.days || '3', 10);
      this.skipWeekends = this.dataset.skipWeekends === 'true';
      this.suffix = this.dataset.suffix || '';
      this.template = this.dataset.template || 'ORDER IN [countdown] AND GET DELIVERY BY [date] [suffix]';
      this.textElement = this.querySelector('.lc-delivery-estimator__text');

      this.updateEstimator();
      this.interval = setInterval(() => this.updateEstimator(), 60000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    updateEstimator() {
      const now = new Date();

      let cutoffDate = new Date(now);
      cutoffDate.setHours(Math.floor(this.cutoffHour), (this.cutoffHour % 1) * 60, 0, 0);

      const isPastCutoff = now >= cutoffDate;
      if (isPastCutoff) {
        cutoffDate.setDate(cutoffDate.getDate() + 1);
      }

      const diffMs = cutoffDate.getTime() - now.getTime();
      const diffMins = Math.ceil(diffMs / (1000 * 60));
      const hours = Math.floor(diffMins / 60);
      const minutes = diffMins % 60;
      const hoursStr = String(hours);
      const minutesStr = String(minutes).padStart(2, '0');
      const countdownText = `${hoursStr}H ${minutesStr}M`;

      let deliveryDate = new Date(now);
      if (isPastCutoff) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
      }
      let daysRemaining = this.deliveryDays;

      while (daysRemaining > 0) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        if (this.skipWeekends) {
          if (deliveryDate.getDay() !== 0 && deliveryDate.getDay() !== 6) {
            daysRemaining--;
          }
        } else {
          daysRemaining--;
        }
      }

      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const isTomorrow = tomorrow.getDate() === deliveryDate.getDate() &&
                         tomorrow.getMonth() === deliveryDate.getMonth() &&
                         tomorrow.getFullYear() === deliveryDate.getFullYear();
      const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      const formattedDate = `${weekdays[deliveryDate.getDay()]}, ${months[deliveryDate.getMonth()]} ${deliveryDate.getDate()}`;
      const dateText = `<strong>${isTomorrow ? 'TOMORROW' : formattedDate}</strong>`;

      let output = this.template;
      output = output.replace(/\[countdown\]/gi, countdownText);
      output = output.replace(/\[date\]/gi, dateText);
      output = output.replace(/\[suffix\]/gi, this.suffix);
      output = output.replace(/\{countdown\}/gi, countdownText);
      output = output.replace(/\{date\}/gi, dateText);
      output = output.replace(/\{suffix\}/gi, this.suffix);

      if (this.textElement) {
        this.textElement.innerHTML = output;
      }
    }
  }

  customElements.define('lc-delivery-estimator', LcDeliveryEstimator);
}
